import { useMemo } from "react"

import { useParams } from "@Components/RouterProvider"
import createStore from "@Stores/base-factories"
import { hookFormList, hookOfferList, hookPublisherList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useAllocationFactory = ({ fetch, siteSelected: { id: siteId } }) => {
  const { id } = useParams()

  return useMemo(() => ({
    propagatePayout: async payload => await fetch({
      method: 'post',
      url: `/allocation/${id}/payout`,
      data: {
        ...payload,
        siteId,
      },
    }),
    duplicate: async payload => await fetch({
      method: 'post',
      url: `/allocation/duplicate`,
      data: {
        ...payload,
      },
    }),
    listSiteVerifications: async params => await fetch({
      url: `/site/${siteId}/verifications`,
      params,
    }),
  }), [fetch, siteId, id])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('allocation')
  .extendHookCollectionsFactory('allocations')
  .extend(useAllocationFactory)
  .extend(hookFormList())
  .extend(hookOfferList())
  .extend(hookPublisherList())
  .factory()

export {
  Provider as AllocationProvider,
  useStore as useAllocationStore,
}
